import { CustomerOptionDto } from '../../../dto/reference';
import { fetchCustomerOptions } from '../api/referenceDataApi';
import { useReferenceOptions } from './useReferenceOptions';

export function useCustomerOptions(enabled = true) {
  return useReferenceOptions<CustomerOptionDto>(fetchCustomerOptions, enabled);
}
